import { ISelectType } from "@4uhub/lib4uhub";
import { Chip, ChipProps } from "@mui/material";
import { memo } from "react";

// Cor por código do StatusGenerateDashboard; o texto vem do próprio Generic
const statusColor: Record<string, ChipProps["color"]> = {
  "1": "default", // Pendente
  "2": "info", // Em processamento
  "3": "primary", // Sucesso (aguardando o reduce)
  "4": "error", // Erro
  "5": "success", // Consolidado
};

interface IGenerateStatusChipProps {
  status: ISelectType | null;
}

const GenerateStatusChip = ({ status }: IGenerateStatusChipProps) => {
  if (!status) return <>-</>;

  return (
    <Chip
      size="small"
      color={statusColor[status.code ?? ""] ?? "default"}
      label={status.name}
    />
  );
};

export default memo(GenerateStatusChip);
